import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
export function RuiInputGroup({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    role: "group",
    class: cx("rui-input-group", className),
    children
  });
}
export function RuiInputGroupAddon({
  children,
  align = "start",
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: cx("rui-input-group__addon", `rui-input-group__addon--${align}`, className),
    children
  });
}
export function RuiInputGroupText({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("span", {
    ...props,
    class: cx("rui-input-group__text", className),
    children
  });
}